import React from 'react';
import { CONFIG } from '../data/config';
export function Encabezado() {
  return <header className="flex items-center gap-3 py-5 md:py-7" data-id="element-49" data-mp="30ju0xgw618lw">
      <img src={CONFIG.logo} width={337} height={152} alt={CONFIG.negocio} className="h-11 w-auto shrink-0 rounded-lg shadow-card md:h-12" data-id="element-50" data-mp="30jbyu3mto062" />
      <p className="min-w-0 text-[12.5px] leading-snug text-ink-soft" data-id="element-51" data-mp="3ai9gqnpqsvg3">{CONFIG.bajada}</p>
    </header>;
}
export function LineaDistribuidor() {
  return <p className="mb-4 flex flex-wrap items-baseline gap-x-1.5 gap-y-1 text-[13px] text-ink-soft" data-id="element-52" data-mp="2htm39eb8jad3">
      <span className="text-[10.5px] font-bold uppercase tracking-[0.09em] text-accent" data-id="element-53" data-mp="2vl0olrsm7nnb">
        Distribuidor oficial
      </span>
      {CONFIG.distribuidor}
    </p>;
}